import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { seyfertPageMeta, seyfertSchema } from 'components/common/schema'
import Template from 'components/cases/seyfert'

const seyfert: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...seyfertPageMeta} />
      <JsonLd data={seyfertSchema} />
      <Template />
    </>
  )
}

export default seyfert
